export const MODAL_ID = 'modal-carousel'